import { locales } from "configs/i18n";
import i18next from "i18next";

i18next.addResources(locales.EN, "CREATE_ASSET_FORM", {
  SUBMIT_BUTTON: "Submit",
});
